import { configureStore } from '@reduxjs/toolkit'
import addFormReducer from './slices/formSlice'

export default configureStore({
    reducer: {
        addForm: addFormReducer
    }
})